export default __webpack_public_path__ + "static/new-italia-2-a09e4ee3b910c18ed62eb827c5630c23.jpg";